import { PaymentMethodDef } from "@swiggy-private/payment-ui";
import { VALID_PAYMENT_METHODS } from "@swiggy-private/payment-core";

export function isPODPaymentMethod(method: PaymentMethodDef): boolean {
    return method.name.toUpperCase() === VALID_PAYMENT_METHODS.POD;
}